<template>
  <div>
    <div class="header py-7 py-lg-4 pt-lg-9"></div>
    <b-container class="mt--8 pb-5" style="max-width: 900px !important">
      <base-header class="pb-6 bg-primary">
        <b-row class="align-items-center py-4">
          <b-col />
        </b-row>
      </base-header>
      <div class="px-0 px-sm-3 mt--12">
        <b-card no-body class="mb-4 px-0">
          <div class="container-fluid px-3 py-5">
            <b-card class="uBind">
              <h2>Thank you</h2>
              <div v-if="isLoading" class="text-muted">
                Please wait…
              </div>
              <div v-else-if="errorMessage" class="text-danger">
                {{ errorMessage }}
              </div>
              <div v-else>
                Thankyou. We are sending you the Indicative quote now. Please
                check your inbox.
              </div>
            </b-card>
          </div>
        </b-card>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "MotorConsentToContinueQuote",
  data() {
    return {
      isLoading: true,
      errorMessage: ""
    };
  },
  async mounted() {
    const quoteGuid = this.$route.params.id;
    if (!quoteGuid) {
      this.isLoading = false;
      this.errorMessage = "Missing quote reference.";
      return;
    }

    try {
      const base = (process.env.VUE_APP_APIENDPOINT || "").replace(/\/$/, "");
      if (!base) {
        throw new Error("API endpoint is not configured.");
      }

      await axios.get(
        `${base}/live/motor/confirmConsentToContinueQuote`,
        {
          params: { quoteGuid }
        }
      );
    } catch (e) {
      const msg =
        (e && e.response && e.response.data && e.response.data.error) ||
        (e && e.message) ||
        "Unable to send the indicative quote email.";
      this.errorMessage = msg;
    } finally {
      this.isLoading = false;
    }
  }
};
</script>
